export const isLocal =
  !process.env.NEXT_PUBLIC_STAGE || process.env.NEXT_PUBLIC_STAGE === 'LOC';
export const isDevelopment = process.env.NEXT_PUBLIC_STAGE === 'DEV' || isLocal;
export const isStage = process.env.NEXT_PUBLIC_STAGE === 'STG';
export const isProduction = process.env.NEXT_PUBLIC_STAGE === 'PRD';
export const googleTagManagerId = process.env.NEXT_PUBLIC_GTM_ID?.trim();
export const shouldLoadGoogleTagManager =
  isProduction &&
  Boolean(googleTagManagerId) &&
  /^GTM-[A-Z0-9]+$/.test(googleTagManagerId ?? '');

export const baseUrl = process.env.NEXT_PUBLIC_BASE_URL as string;
export const assetsUrl =
  process.env.NEXT_PUBLIC_ASSETS_URL?.trim().replace(/\/+$/, '') ||
  'https://cdn-static.zep.us';
export const bakedAvatarAssetsUrl = assetsUrl;
export const zepBaseUrl = process.env.NEXT_PUBLIC_ZEP_BASEURL?.trim();
export const coreBaseUrl =
  process.env.NEXT_PUBLIC_CORE_BASE_URL?.trim() || baseUrl;
export const getBaseUrlWithLocale = (locale: string) =>
  `${process.env.NEXT_PUBLIC_BASE_URL}${locale === 'ko' ? '' : `/${locale}`}`;

export const CMS_CDN = process.env.NEXT_PUBLIC_CMS_CDN_BASE_URL as string;
